var _path, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInputSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H42V42H8C3.58172 42 0 38.4183 0 34V8Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_401_951",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_401_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6 30L22.3 23.7C21.8 24.1 21.225 24.4167 20.575 24.65C19.925 24.8833 19.2333 25 18.5 25C16.6833 25 15.1458 24.3708 13.8875 23.1125C12.6292 21.8542 12 20.3167 12 18.5C12 16.6833 12.6292 15.1458 13.8875 13.8875C15.1458 12.6292 16.6833 12 18.5 12C20.3167 12 21.8542 12.6292 23.1125 13.8875C24.3708 15.1458 25 16.6833 25 18.5C25 19.2333 24.8833 19.925 24.65 20.575C24.4167 21.225 24.1 21.8 23.7 22.3L30 28.6L28.6 30ZM18.5 23C19.75 23 20.8125 22.5625 21.6875 21.6875C22.5625 20.8125 23 19.75 23 18.5C23 17.25 22.5625 16.1875 21.6875 15.3125C20.8125 14.4375 19.75 14 18.5 14C17.25 14 16.1875 14.4375 15.3125 15.3125C14.4375 16.1875 14 17.25 14 18.5C14 19.75 14.4375 20.8125 15.3125 21.6875C16.1875 22.5625 17.25 23 18.5 23Z",
    fill: "#F25B08"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputSearchIcon);
export default __webpack_public_path__ + "static/media/input-search-icon.fd346a9490227ae2ba54c63510fa7fc0.svg";
export { ForwardRef as ReactComponent };